import { useNavigate } from "react-router-dom";
import GradientButton from "./Button/GradientButton";
import { logOutAws } from "../utils/aws";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthenticated } from "../slices/authSlice";
import { setuserAttributesReducer } from "../slices/userSlice";

const NotApproved = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  console.log("🚀 ~ AllRoutes ~ userAllFormsDetails:", userAllFormsDetails);
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  console.log("🚀 ~ NotApproved ~ basicInfoData:", basicInfoData);
  const handleLogout = () => {
    logOutAws();
    // localStorage.removeItem("accessToken");
    // localStorage.removeItem("username");
    dispatch(setIsAuthenticated(null));
    dispatch(setuserAttributesReducer(null));
    navigate("/signin");
  };
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="text-4xl font-bold mb-4">You have Rejected by Admin</div>
      <p className="text-lg text-gray-600 mb-8">
        Reason: {basicInfoData?.RejectMessage}.
      </p>
      <div className="flex space-x-4">
        <div className="w-10 h-10 rounded-full bg-orange-500"></div>
        <div className="w-10 h-10 rounded-full bg-orange-400"></div>
        <div className="w-10 h-10 rounded-full bg-orange-300"></div>
      </div>
      <GradientButton type="button" onClick={handleLogout} className="mt-5">
        Logout
      </GradientButton>
    </div>
  );
};

export default NotApproved;
